import { PicksRequest } from '@cds/query-objects';

import { BetslipGroupInformation } from '../../../../core/groups/betslip-group-information';
import { V2ParticipantPickId } from '../../../../core/picks/pick-id';
import { PickRequestBuilder } from './pick-request.builder';

export class V2ParticipantPickRequestBuilder implements PickRequestBuilder<V2ParticipantPickId> {
    getPickDataRequest(id: V2ParticipantPickId, request: PicksRequest, _: boolean, groupInfo?: BetslipGroupInformation) {
        const mappedPicks = Object.keys(id.participantIds).map((participantId) => ({
            fixtureId: id.fixtureId,
            participantId: +participantId,
            isClassicBetBuilder: false,
        }));
        request.tv2Picks.push(...mappedPicks);
    }
}
